
import PancakeFactoryABI from './ABI/PancakeFactoryABI.json'
import PancakeV3FactoryABI from './ABI/PancakeV3Factory.json'
import QuoterV2ABI from './ABI/QuoterV2.json'
import AllowABI from './ABI/allowABI.json'
import { RouterType, TokenType } from '@/store/type'
export { default as ERC20ABI } from './ABI/ERC20ABI.json'
export { default as PancakeRouterABI } from './ABI/PancakeRouterABI.json'
export { default as PancakeFactoryABI } from './ABI/PancakeFactoryABI.json'
export { default as PancakePairABI } from './ABI/PancakePairABI.json'
export { default as SenderTokenABI } from './ABI/SenderTokenABI.json'
export { default as MemberABI } from './ABI/MemberABI.json'
export { default as RPCLIST } from './RPCLIST.json'
export { default as PiXieABI } from './PiXiuCheck/pixiuABI.json'
export { default as PiXieBytecode } from './PiXiuCheck/pixieBytecode.json'
export { default as SwapABI } from './ABI/swapABI.json'
export { default as SwapRouter } from './ABI/SwapRouter.json'
export { default as ClQuoter } from './ABI/ClQuoter.json'
export { default as QuoterV2 } from './ABI/QuoterV2.json'
export { default as PancakeV3Factory } from './ABI/PancakeV3Factory.json'
export { default as Flap } from './ABI/Flap.json'
export { default as poolManagerABI } from './ABI/poolManagerABI.json'
export { default as MULTICALL3_ABI } from './ABI/MULTICALL3_ABI.json'
export { default as WalletToolAddressABI } from './ABI/WalletToolAddressABI.json'

export type ChainIdType = 56 | 97 | 42161 | 1  | 8453 | 137 | 196 | 4663 | 5042;


export const isDev = import.meta.env.DEV;

export const zeroAddress = "0x0000000000000000000000000000000000000000"
export const DEAD = '0x000000000000000000000000000000000000dEaD'
export const MYAPIKEY = `CP71ZJX8V3YRF24HGXE7EMIN7ISUNQJ8MI`
export const FEE_ADDRESS = '0x3d7295cDafD0d65E27a63CAE1625f9f3DC1419ef'

// 路由工厂地址
export const FactoryContract = {
  address: {
    1: '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f',
    56: '0xca143ce32fe78f1f7019d7d551a6402fc5350c73',
    97: '0x6725f303b657a9451d8ba641348b6761a6cc7a17',
  },
  abi: PancakeFactoryABI,
}

export const V3FactoryContract = {
  abi: PancakeV3FactoryABI,
}

export const UniversalRouter = {
  address: {
    1: '0x66a9893cc07d91d95644aedd05d03f95e1dba8af',
    56: '0x1906c1d672b88cd1b9ac7593301ca990f94eae07',
    97: '0x87FD5305E6a40F378da124864B2D479c2028BD86',
    1030: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
    1116: '0x1BB72E0CbbEA93c08f535fc7856E0338D7F7a8aB',
    42161: '0xFE6508f0015C778Bdcc1fB5465bA5ebE224C9912',
    // 7899: '0xA7D3A50FF7867C88326C7932e0284154880Bac59',
    8453: '0x13f4EA83D0bd40E75C8222255bc855a974568Dd4',
    20201022: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
    137: '0x13f4EA83D0bd40E75C8222255bc855a974568Dd4',
    196: '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD',
    4663: '0x8876789976decbfcbbbe364623c63652db8c0904',
    5042: '0x4fcA4a51Ab4F23A7447b3284fBd7D73289A89Fb1',
  },
  abi: [
    'function execute(bytes calldata commands, bytes[] calldata inputs, uint256 deadline) external payable'
  ]
}

export const Permit2 = {
  address: {
    1: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
    56: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
    97: '0x31c2f6fcff4f8759b3bd5bf0e1084a055615c768',
    137: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
  },
  abi: [
    'function allowance(address owner, address token, address spender) view returns (uint160 amount, uint48 expiration, uint48 nonce)'
  ]
}


export const Quoter = {
  address: {
    1: '0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997',
    56: '0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997',
    97: '0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2',
    137: '0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997',
  },
  abi: QuoterV2ABI
}

export const ALLOWANCE = {
  1: '0xfd00998b9bbdeeaf3e71531856d2bd9068e19401',
  56: '0x54E19d66De52FDf59d0Ed7494460ef20001d6dd9',
  97: '0x0A8E1214A62D8525991636ad5276Cb8F98b4669E',
  8453: '0xfa17eAa43FA7cC50cfA0f88fa997CD80715f6a16',
  137: '0x03502c7F5b39A6795f7F8C812F6A7d4fb336Aca3',
  196: '0xE53D55aBa787e5584219B4B510144474c186B140',
  143: '0xA7D3A50FF7867C88326C7932e0284154880Bac59',
  4663: '0xFC47E7f97E53a001279190dBa434EfA350161a35',

  ABI: AllowABI
}


export const WALLETTOOL: Record<ChainIdType, string> = {
  1: '0xc239938ac88F1e2163d581F7cf2AA58C7Ce7f0a9',
  56: '0x759c4890CFF37fbA701C1beE56D22234B890DdD2',
  97: '0x3eF518677E0Ae893150E910F26e12EB9ccF57B57',
  // 12133: '0x876589Af867b1a1C70Bbff7874F129A687887B9f',
  // 1030: '0xf3b49b997d12A21980E73919449bCF2249C42AF9',
  // 1116: '0x17aa8D7B32c804D18Ea556676aA5773a4916c69e',
  42161: '0x4c42BDdF273446536B8AA0d28DD57223c67F80Ec',
  // 7899: '0xA7D3A50FF7867C88326C7932e0284154880Bac59',
  8453: '0xA136D35C7a34e076Af4C69D46A60398a2de7E29c',
  // 20201022: '0xFF739a44cbECA8803111De9FB2360D444329E205',
  137: '0xB9B53d2D25B4b2aDe84F5607359A180f2E1B793F',
  196: '0x3afe8C19A64b4A577DA751F14e4240CA5389371A',
  4663: '0xFC47E7f97E53a001279190dBa434EfA350161a35',
  5042: '0x898829E26644d3F7CB99D29cb706f7B1699bf907'
}


export const newSwapConfig: Record<ChainIdType, any> = {
  1: [
    { label: 'Uniswap V2', universalRouter: '0x66a9893cc07d91d95644aedd05d03f95e1dba8af', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x1F98431c8aD98523631AE4a59f267346ea31F984', quoter: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e" },
    { label: 'Uniswap V3', universalRouter: '0x66a9893cc07d91d95644aedd05d03f95e1dba8af', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x1F98431c8aD98523631AE4a59f267346ea31F984', quoter: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e" },
  ],
  56: [
    { label: 'pancakeSwap V2', universalRouter: '0xd9C500DfF816a1Da21A48A732d3498Bf09dc9AEB', permit: '0x31c2f6fcff4f8759b3bd5bf0e1084a055615c768', v3FactoryContract: '0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865', quoter: "0x7a250d5630b4cf539739df2c5dacb4c659f2488d" },
    { label: 'pancakeSwap V3', universalRouter: '0xd9C500DfF816a1Da21A48A732d3498Bf09dc9AEB', permit: '0x31c2f6fcff4f8759b3bd5bf0e1084a055615c768', v3FactoryContract: '0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865', quoter: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997" },
    { label: 'pancakeSwap V4CLAMM', universalRouter: '0xd9C500DfF816a1Da21A48A732d3498Bf09dc9AEB', permit: '0x31c2f6fcff4f8759b3bd5bf0e1084a055615c768', v3FactoryContract: '0xa0FfB9c1CE1Fe56963B0321B32E7A0302114058b', quoter: "0xd0737C9762912dD34c3271197E362Aa736Df0926" },
    { label: 'Uniswap V2', universalRouter: '0x1906c1d672b88cd1b9ac7593301ca990f94eae07', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0xdB1d10011AD0Ff90774D0C6Bb92e5C5c8b4461F7', quoter: "0x78D78E420Da98ad378D7799bE8f4AF69033EB077" },
    { label: 'Uniswap V3', universalRouter: '0x1906c1d672b88cd1b9ac7593301ca990f94eae07', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0xdB1d10011AD0Ff90774D0C6Bb92e5C5c8b4461F7', quoter: "0x78D78E420Da98ad378D7799bE8f4AF69033EB077" },
    { label: 'four', universalRouter: '0x66A963183620E820e5EFB4a696327C100F113a9c', permit: '0x5c952063c7fc8610FFDB798152D69F0B9550762b', v3FactoryContract: '0x66A963183620E820e5EFB4a696327C100F113a9c', quoter: "0x66A963183620E820e5EFB4a696327C100F113a9c" },
    { label: 'flap', universalRouter: '0xe8298d9685447833D00c261E2F31f567DEF73080', permit: '0xe8298d9685447833D00c261E2F31f567DEF73080', v3FactoryContract: '0xe8298d9685447833D00c261E2F31f567DEF73080', quoter: "0xe8298d9685447833D00c261E2F31f567DEF73080" }
  ],

  97: [
    { label: 'pancakeSwap', universalRouter: '0x87FD5305E6a40F378da124864B2D479c2028BD86', permit: '0x31c2f6fcff4f8759b3bd5bf0e1084a055615c768', v3FactoryContract: '0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865', quoter: "0x7a250d5630b4cf539739df2c5dacb4c659f2488d" },
    { label: 'pancakeSwap V3', universalRouter: '0x87FD5305E6a40F378da124864B2D479c2028BD86', permit: '0x31c2f6fcff4f8759b3bd5bf0e1084a055615c768', v3FactoryContract: '0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865', quoter: "0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2" }
  ],
  137: [
    { label: 'QuickSwap V2', universalRouter: '0xD0Df6d3db9af15d531Aa332507a969185507B7Ef', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x411b0fAcC3489691f28ad58c47006AF5E3Ab3A28', quoter: "0x7a250d5630b4cf539739df2c5dacb4c659f2488d" },
    // { label: 'QuickSwap V3',universalRouter:'0xD0Df6d3db9af15d531Aa332507a969185507B7Ef', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3',  v3FactoryContract:'0x411b0fAcC3489691f28ad58c47006AF5E3Ab3A28', quoter: "0x7a250d5630b4cf539739df2c5dacb4c659f2488d"  },
    { label: 'Uniswap V2', universalRouter: '0x1095692a6237d83c6a72f3f5efedb9a670c49223', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x1F98431c8aD98523631AE4a59f267346ea31F984', quoter: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e" },
    { label: 'Uniswap V3', universalRouter: '0x1095692a6237d83c6a72f3f5efedb9a670c49223', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x1F98431c8aD98523631AE4a59f267346ea31F984', quoter: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e" },
  ],
  // 1116: [
  //   { label: 'LongSwap V2', address: '0xc885C4a8B112B8a165338566421c685024Ec44F9' },
  // ],
  42161: [
    { label: 'Uniswap V2', universalRouter: '0xa51afafe0263b40edaef0df8781ea9aa03e381a3', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x1F98431c8aD98523631AE4a59f267346ea31F984', quoter: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e" },
    { label: 'Uniswap V3', universalRouter: '0xa51afafe0263b40edaef0df8781ea9aa03e381a3', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x1F98431c8aD98523631AE4a59f267346ea31F984', quoter: "0x61fFE014bA17989E743c5F6cB21bF9697530B21e" },
  ],
  8453: [
    { label: 'Uniswap V2', universalRouter: '0x6ff5693b99212da76ad316178a184ab56d299b43', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x33128a8fC17869897dcE68Ed026d694621f6FDfD', quoter: "0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a" },
    { label: 'Uniswap V3', universalRouter: '0x6ff5693b99212da76ad316178a184ab56d299b43', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x33128a8fC17869897dcE68Ed026d694621f6FDfD', quoter: "0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a" },
  ],
  196: [
    { label: 'potatoswap V2', universalRouter: '0x16511103571BB354F5961beE733F3d4BC4B7F2AB', permit: '0x97d242Be27753A8e4abB9dC763a07c7703B5227b', v3FactoryContract: '0x33128a8fC17869897dcE68Ed026d694621f6FDfD', quoter: "0x0d5e0f971ed27fbff6c2837bf31316121532048d" },
  ],
  4663: [
    { label: 'Uniswap V2', universalRouter: '0x8876789976decbfcbbbe364623c63652db8c0904', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x1f7d7550B1b028f7571E69A784071F0205FD2EfA', quoter: "0x33e885ed0ec9bf04ecfb19341582aadcb4c8a9e7" },
    { label: 'Uniswap V3', universalRouter: '0x8876789976decbfcbbbe364623c63652db8c0904', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0x1f7d7550B1b028f7571E69A784071F0205FD2EfA', quoter: "0x33e885ed0ec9bf04ecfb19341582aadcb4c8a9e7" },
    { label: 'flap', universalRouter: '0x4c310BD9E5c8B806fbA5E77D475369Ea4798F6ad', permit: '0x4c310BD9E5c8B806fbA5E77D475369Ea4798F6ad', v3FactoryContract: '0x4c310BD9E5c8B806fbA5E77D475369Ea4798F6ad', quoter: "0x4c310BD9E5c8B806fbA5E77D475369Ea4798F6ad" }
  ],
  5042: [{ label: 'Uniswap V2', universalRouter: '0x4fcA4a51Ab4F23A7447b3284fBd7D73289A89Fb1', permit: '0x000000000022D473030F116dDEE9F6B43aC78BA3', v3FactoryContract: '0xf0db7b58379503491d857db50ac9ece64c653918', quoter: "0x7DfD4F31be6814D2906BDE155c3e1B146EAc1468" }]
}
export const RouterConfig: Record<ChainIdType, RouterType[]>  = {
  5042: [
    { label: 'Uniswap V2', address: '0x1f7d7550B1b028f7571E69A784071F0205FD2EfA' },
  ],
  1: [{ label: 'Uniswap V2', address: '0x7a250d5630b4cf539739df2c5dacb4c659f2488d' },
  { label: 'Uniswap V3', address: '0x7a250d5630b4cf539739df2c5dacb4c659f2488d' }],
  56: [
    { label: 'pancakeSwap V2', address: '0x10ED43C718714eb63d5aA57B78B54704E256024E' },
    { label: 'pancakeSwap V3', address: '0x1b81D678ffb9C0263b24A97847620C99d213eB14' },
    { label: 'pancakeSwap V4CLAMM', address: '0x1b81D678ffb9C0263b24A97847620C99d213eB14' },
    { label: 'Uniswap V2', address: '0x4752ba5DBc23f44D87826276BF6Fd6b1C372aD24' },
    { label: 'Uniswap V3', address: '0x4752ba5DBc23f44D87826276BF6Fd6b1C372aD24' },
    { label: 'four', address: '0x66A963183620E820e5EFB4a696327C100F113a9c' },
    { label: 'flap', address: '0xe8298d9685447833D00c261E2F31f567DEF73080' }
  ],
  97: [
    { label: 'pancakeSwap', address: '0xd99d1c33f9fc3444f8101754abc46c52416550d1' },
    { label: 'pancakeSwap V3', address: '0x1b81D678ffb9C0263b24A97847620C99d213eB14' }
  ],
  // 1030: [{ label: 'cfxSwap', address: '0x62b0873055bf896dd869e172119871ac24aea305' }],
  // 1116: [
  //   { label: 'LongSwap V2', address: '0xc885C4a8B112B8a165338566421c685024Ec44F9' },
  // ],
  42161: [
    { label: 'Uniswap V2', address: '0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24' },
    { label: 'Uniswap V3', address: '0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24' },
    // { label: 'sushiswap V2', address: '0x1b02da8cb0d097eb8d57a175b88c7d8b47997506' },
  ],
  8453: [
    { label: 'Uniswap V2', address: '0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24' },
    { label: 'Uniswap V3', address: '0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24' },
  ],
  137: [
    { label: 'QuickSwap V2', address: '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff' },
    // { label: 'QuickSwap V3', address: '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff' },
    { label: 'Uniswap V2', address: '0xedf6066a2b290C185783862C7F4776A2C8077AD1' },
    { label: 'Uniswap V3', address: '0xE592427A0AEce92De3Edee1F18E0157C05861564' },
  ],
  196: [
    { label: 'potatoswap V2', address: '0x881fb2f98c13d521009464e7d1cbf16e1b394e8e' },
    // { label: 'dyorswap V2', address: '0x1e690f24f704672e44255013c2cb22fc04c46036' },
  ],
  4663: [
    { label: 'Uniswap V2', address: '0x89e5db8b5aa49aa85ac63f691524311aeb649eba' },
    { label: 'Uniswap V3', address: '0x89e5db8b5aa49aa85ac63f691524311aeb649eba' },
    { label: 'flap', address: '0x4c310BD9E5c8B806fbA5E77D475369Ea4798F6ad' },
  ],
  // 1116: []
}

export const MainTokenConfig: Record<ChainIdType, TokenType[]> = {
  5042: [
    { symbol: 'USDC', address: '0x3600000000000000000000000000000000000000', decimals: 18 },
  ],
  1: [
    { symbol: 'ETH', address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', decimals: 18 },
    { symbol: 'USDT', address: '0xdAC17F958D2ee523a2206206994597C13D831ec7', decimals: 6 },
    { symbol: 'USDC', address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', decimals: 6 },
  ],
  56: [
    { symbol: 'BNB', address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', decimals: 18 },
    { symbol: 'USDT', address: '0x55d398326f99059fF775485246999027B3197955', decimals: 18 },
    { symbol: 'BUSD', address: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56', decimals: 18 },
    { symbol: 'USD1', address: '0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d', decimals: 18 },
    { symbol: 'U', address: '0xce24439f2d9c6a2289f741120fe202248b666666', decimals: 18 },
  ],
  97: [
    { symbol: 'tBNB', address: `0xae13d989dac2f0debff460ac112a837c89baa7cd`, decimals: 18 },
    { symbol: 'USDT', address: '0x89614e3d77C00710C8D87aD5cdace32fEd6177Bd', decimals: 18 },
    { symbol: 'BUSD', address: '0x8516Fc284AEEaa0374E66037BD2309349FF728eA', decimals: 18 },
  ],
  // 1030: [
  //   { symbol: 'CFX', address: `0x14b2d3bc65e74dae1030eafd8ac30c533c976a9b`, decimals: 18 },
  //   { symbol: 'USDT', address: `0xfe97e85d13abd9c1c33384e796f10b73905637ce`, decimals: 18 },
  // ],
  // 1116: [
  //   { symbol: 'CORE', address: `0x40375C92d9FAf44d2f9db9Bd9ba41a3317a2404f`, decimals: 18 },
  //   { symbol: 'USDT', address: `0x900101d06A7426441Ae63e9AB3B9b0F63Be145F1`, decimals: 6 },
  // ],
  42161: [
    { symbol: 'ETH', address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', decimals: 18 },
    { symbol: 'USDT', address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9', decimals: 6 },
    { symbol: 'ARB', address: '0x912ce59144191c1204e64559fe8253a0e49e6548', decimals: 18 },

  ],
  // 7899: [
  //   { symbol: 'SVE', address: '0x6A7cf156543bAB6699aa2146d1f8E6F3E036757f', decimals: 18 },
  //   { symbol: 'USDT', address: '0xB06447Ce9D038be85619a6429535cC187AC84a40', decimals: 18 },
  // ],
  8453: [
    { symbol: 'ETH', address: '0x4200000000000000000000000000000000000006', decimals: 18 },
    { symbol: 'USDC', address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913', decimals: 6 },
  ],
  // 20201022: [
  //   { symbol: 'WPG', address: '0x0cf4071940782b640d0b595cb17bdf3e90869d70', decimals: 18 },
  //   { symbol: 'USDT', address: '0x02f9bebf5e54968d8cc2562356c91ecde135801b', decimals: 18 },
  // ],
  137: [
    { symbol: 'POL', address: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', decimals: 18 },
    { symbol: 'USDT', address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F', decimals: 6 },
    { symbol: 'LGNS', address: '0xeb51d9a39ad5eef215dc0bf39a8821ff804a0f01', decimals: 9 },
    { symbol: 'DAI', address: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063', decimals: 18 },
  ],
  196: [
    { symbol: 'OKB', address: '0xe538905cf8410324e03A5A23C1c177a474D59b2b', decimals: 18 },
    { symbol: 'USDT', address: '0x1E4a5963aBFD975d8c9021ce480b42188849D41d', decimals: 6 },
  ],
  4663: [
    { symbol: 'ETH', address: '0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73', decimals: 18 },
    { symbol: 'USDG', address: '0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168', decimals: 6 },
  ],
}

export const MAINADDRESS = [
  '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
  '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
  '0x14b2d3bc65e74dae1030eafd8ac30c533c976a9b',
  '0x40375C92d9FAf44d2f9db9Bd9ba41a3317a2404f',
  '0x4200000000000000000000000000000000000006',
  '0x0cf4071940782b640d0b595cb17bdf3e90869d70',
  '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
  '0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73',
  '0x3600000000000000000000000000000000000000',
]

//每个 主链合约地址
export const SenderMainInfo = {
  1: [{ symbol: `ETH`, address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', decimals: '18' }],
  56: [{ symbol: `BNB`, address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c', decimals: '18' }],
  97: [{ symbol: `TBNB`, address: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd', decimals: '18' }],
  128: [{ symbol: `HT`, address: '0x5545153CCFcA01fbd7Dd11C0b23ba694D9509A6F', decimals: '18' }],
  10001: [{ symbol: `ETHW`, address: '0x7Bf88d2c0e32dE92CdaF2D43CcDc23e8Edfd5990', decimals: '18' }],
  513100: [{ symbol: `ETF`, address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', decimals: '18' }],
  // 1030: [{ symbol: 'CFX', address: `0x14b2d3bc65e74dae1030eafd8ac30c533c976a9b`, decimals: '18' }],
  1116: [{ symbol: 'CORE', address: `0x40375C92d9FAf44d2f9db9Bd9ba41a3317a2404f`, decimals: '18' }],
  42161: [{ symbol: 'ETH', address: `0x82aF49447D8a07e3bd95BD0d56f35241523fBab1`, decimals: '18' }],
  7899: [{ symbol: 'SVE', address: `0x6A7cf156543bAB6699aa2146d1f8E6F3E036757f`, decimals: '18' }],
  8453: [{ symbol: 'ETH', address: `0x4200000000000000000000000000000000000006`, decimals: '18' }],
  20201022: [{ symbol: 'PG', address: `0x0cf4071940782b640d0b595cb17bdf3e90869d70`, decimals: '18' }],
  137: [{ symbol: 'POL', address: `0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270`, decimals: '18' }],
  196: [{ symbol: 'OKB', address: `0xe538905cf8410324e03A5A23C1c177a474D59b2b`, decimals: '18' }],
  4663: [{ symbol: `ETH`, address: '0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73', decimals: '18' }],
  5042: [{ symbol: `USDC`, address: '0x3600000000000000000000000000000000000000', decimals: '18' }],
}
// 批量发送代币合约地址
export const SENDERTOKENCONTRACT: Record<ChainIdType, string> = {
  56: '0xF8Ae467E58cfC0f458AAD907D6d2D95fA0026f72',
  97: '0x67aac04a06a40639FCecaBcDa2e324d200558FAB',
  42161: '0x1eE7f7DBe6aa0AC2374Bf86A5597028d81069eBE',
  // 7899: '0x1F7907250992923450e6F599Bb91B3308A9eaadd',
  1: '0x1eE7f7DBe6aa0AC2374Bf86A5597028d81069eBE',
  // 12133: '0x53C7A70eBd762aBA076E1B0c2Ab97f45Dc8e22e4',
  // 1116: '0xa290c5Bb06Eaf009634ae3D0F15B4345c2F9F6aE',
  8453: '0xc24339a5D1933316cd5c2e712fb4402b8fa4D026',
  // 20201022: '0x0521af587fB12555F1E5beD4211dBb01A5A67E29',
  137: '0xFC47E7f97E53a001279190dBa434EfA350161a35',
  196: '0x1F7907250992923450e6F599Bb91B3308A9eaadd',
  4663: '0x1F7907250992923450e6F599Bb91B3308A9eaadd',
  5042: '0xA136D35C7a34e076Af4C69D46A60398a2de7E29c'
}

export const SENDTOKEN_PRICE = {
  56: '0.01',
  97: '0.02',
  42161: '0.002',
  7899: '0',
  1: '0.002',
  12133: '0',
  1116: '1',
  8453: '0.002',
  204: '0',
  128: '0',
  20201022: '0',
  137: '0',
  196: '0.05',
  4663: '0.002',
  5042: '2',
}
export const NOVIP_AMOUNT: Record<ChainIdType, string> = {
  56: '0.0001',
  97: '0.0001',
  42161: '0.00003',
  1: '0.00003',
  // 1116: '0.2',
  8453: '0.00003',
  137: '0.2',
  196: '0.001',
  4663: '0.00003',
  5042: '0.00003',
}

// 会员合约地址
// export const MUMBERADDRESS = {
//   56: '0x4fEc2d3998fDe732d7b9f5e0cf8b99fa52C01cd2',
//   97: '0x9150A66bD6279cCB6AAa968B976998Db58D66B75',
// }

export const MUMBERADDRESS = {
  56: '0x5302d4acbb0ba16154a44ea34aa58ccd0e6de222',
  97: '0xaEDaFb23d22B357E79bf7935ead8B12DFE918d14',
}

// //单独代币开通市值会员
// export const TOKENBOTCONTRACT = {
//   address: {
//     56: '0x0D3ecC6949D345D88B9AAbB11A4e7a12c14D0144',
//     97: '0xf80473f4685Db248077556915c5E74234eDB807c',
//   },
//   abi: MidlleInvitationABI,
// }


